function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import TextInputWidget from './TextInputWidget';

const TextareaWidget = props => {
  const {
    uiSchema
  } = props;
  const numberOfLines = uiSchema['ui:options'] && uiSchema['ui:options'].rows || 2;
  return /*#__PURE__*/React.createElement(TextInputWidget, _extends({}, props, {
    multiline: true,
    numberOfLines: numberOfLines
  }));
};

TextareaWidget.propTypes = {
  uiSchema: PropTypes.shape({
    'ui:options': PropTypes.shape({
      rows: PropTypes.number
    })
  }).isRequired
};
export default TextareaWidget;